import { isPrimaryCampaign } from "./countries";

export const defaultLanguage = isPrimaryCampaign ? "en" : "es";

const SUPPORTED_LANGUAGES = [
  { key: "en", defaultValue: "ENGLISH" },
  { key: "fr", defaultValue: "FRENCH" },
  { key: "es", defaultValue: "SPANISH" }
];
export default SUPPORTED_LANGUAGES;
